// Use relative paths in dev so Vite proxy handles CORS/cookies.
const getAppBase = () =>
  import.meta.env.DEV
    ? '/sapps/buyonline/application'
    : `${import.meta.env.VITE_BCBSNC_URL}/sapps/buyonline/application`

export const BUYONLINE_QUOTE_URL = () =>
  `${getAppBase()}/BolMicroService_quote.action`
export const BUYONLINE_START_URL = () =>
  `${getAppBase()}/OnlineApplicationControl_startNew.action`
export const BUYONLINE_INITIAL_URL = () =>
  `${getAppBase()}/BolMicroService_initial.action`
export const BUYONLINE_EMAIL_URL = () =>
  `${getAppBase()}/BolMicroService_email.action`
export const BUYONLINE_AGENT_AUTH_URL = () =>
  `${getAppBase()}/AgentAuthControl.action`
export const AGENT_SESSION_URL = () =>
  `${import.meta.env.VITE_BCBSNC_URL}/sapps/buyonline/rest/applicationService/getProducerInfo`
export const AGENT_PORTAL_DASH_URL = () =>
  `${import.meta.env.VITE_AGENT_PORTAL_URL}/producers/secure/individual/index.htm`

// Ancillary rates API endpoints
export const VISION_RATES_API = () =>
  `${import.meta.env.VITE_API_URL}/members/v1/vision/rates`
export const DENTAL_RATES_API = () =>
  `${import.meta.env.VITE_API_URL}/members/v1/api/dental/rating`

export interface Producer {
  producerNumber: string
  producerName?: string
  firstName?: string
  middleInitial?: string
  lastName?: string
  workPhoneNumber?: string
  email?: string
  status?: string
}
